/* smooth expanding/collapsing Q&A block */

// returns a function for click handler for expanding boxes with button
function createExpandingBoxHandler(expandableBoxSelector, parentClass) {
    const expandedClass = 'expanded';
    const transitionEvt = 'transitionend';

    return evt => {
        const { currentTarget } = evt;

        if (currentTarget) {
            const parentNode = currentTarget.parentNode.parentNode;

            const expandableBox = parentNode.querySelector(expandableBoxSelector);

            const isOpen = parentNode.classList.contains(expandedClass);

            currentTarget.setAttribute('aria-expanded', !isOpen);

            // open parentNode if it's not open
            if (!isOpen) {
                parentNode.classList.add(expandedClass);

                // set height to auto after css transition so the box is still responsive
                expandableBox.addEventListener(transitionEvt, function onTransitionEnd() {
                    expandableBox.style.height = 'auto';
                    // remove listener to not have multiaple onTransitionEnd calls
                    expandableBox.removeEventListener(transitionEvt, onTransitionEnd);
                });
                // expandes the box based on its content
                expandableBox.style.height = expandableBox.scrollHeight + 'px';
            } else {
                parentNode.classList.remove(expandedClass);
                // set height based on the content of the box so the transition works
                expandableBox.style.height = expandableBox.scrollHeight + 'px';
                // waits a milisecond so the transition works
                setTimeout(() => (expandableBox.style.height = 0), 1);
            }
        }
    };
}

const qaButtonElements = document.querySelectorAll('.wp-block-snla-q-a button');
const personListButtonElements = document.querySelectorAll('.wp-block-snla-person-list button');
const dropdownComponents = document.querySelectorAll('.wp-block-snla-show-more');
const dropdownFactBoxes = document.querySelectorAll('.wp-block-snla-facts.expandable');

const topBanner = document.querySelectorAll('.wp-block-snla-top-one-one-columns');

for (let t = 0; t < topBanner.length; t++) {
    const area = topBanner[t].children[0];

    if (area.children.length === 0) {
        topBanner[t].classList.add('empty-first-row');
    }
}

const qaButtonClickHandler = createExpandingBoxHandler('dd', 'wp-block-snla-q-a');

for (let i = 0; i < qaButtonElements.length; i++) {
    qaButtonElements[i].addEventListener('click', qaButtonClickHandler);
}

for (let i = 0; i < dropdownComponents.length; i++) {
    const btn = dropdownComponents[i].querySelector('.dropdown-btn-expansion');
    const expansionArea = dropdownComponents[i].querySelector('.expandsion-area');
    const ctrlId = `showMoreBtn${i + 1}`;

    btn.setAttribute('aria-controls', ctrlId);
    if (!btn.innerText) btn.innerHTML = 'mer';
    if (expansionArea) expansionArea.setAttribute('id', ctrlId);
    if (btn) btn.addEventListener('click', dropdownButtonClickHandler);
}

function dropdownButtonClickHandler(evt) {
    const { target } = evt;

    if (target.nodeName.toLowerCase() === 'button') {
        const dropdownBlockElement = target.parentNode;
        const expansionArea = dropdownBlockElement.querySelector('.expandsion-area');

        // if expanded not in classname
        if (dropdownBlockElement.className === 'wp-block-snla-show-more') {
            dropdownBlockElement.classList.add('expanded');
            expansionArea.style.maxHeight = expansionArea.scrollHeight + 'px';
            target.setAttribute('aria-expanded', true);
        } else {
            dropdownBlockElement.classList.remove('expanded');
            expansionArea.removeAttribute('style');
            target.setAttribute('aria-expanded', false);
        }
    }
}

for (let f = 0; f < dropdownFactBoxes.length; f++) {
    const factId = `factboxid${f + 1}`;
    const expandbtn = dropdownFactBoxes[f].querySelector('button.btn-expandcontent');
    expandbtn.setAttribute('aria-controls', factId);
    expandbtn.setAttribute('aria-label', 'Vis mer');
    dropdownFactBoxes[f].setAttribute('id', factId);
    if (expandbtn) expandbtn.addEventListener('click', dropdownFactClickHandler);
}

function dropdownFactClickHandler(evt) {
    const { target } = evt;
    const factCtrlId = target.getAttribute('aria-controls');
    const factBox = document.getElementById(factCtrlId);
    if (factBox) {
        if (factBox.classList.contains('is-expanded')) {
            // close
            factBox.classList.remove('is-expanded');
            target.setAttribute('aria-expanded', false);
            target.setAttribute('aria-label', 'Vis mer');
        } else {
            // open
            factBox.classList.add('is-expanded');
            target.setAttribute('aria-expanded', true);
            target.setAttribute('aria-label', 'Vis mindre');
        }
    }
}

const personListButtonClickHandler = createExpandingBoxHandler(
    '.wp-person-list-list',
    'wp-block-snla-person-list'
);

for (let i = 0; i < personListButtonElements.length; i++) {
    personListButtonElements[i].addEventListener('click', personListButtonClickHandler);
}
